import React from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'

import PageSection from '../components/layout/PageSection'
import VideosCarousel from '../containers/content/videos/Carousel'
import { useI18N } from '../../libraries/i18n/hook'
import DocumentsCarousel from '../containers/content/documents/Carousel'
import NextEvents from '../containers/events/NextEvents'
import GptForm from '../containers/gpt/form'
import config from '../../config'
import ContinueWatching from '../containers/content/videos/ContinueWatching'
import { useHistory, useLastVideos, useRecommendedVideos } from '../../hocs/content/useVideos'
import { useLastDocuments } from '../../hocs/content/useDocuments'
import { CurrentUserContext } from '../../libraries/auth'
import JobOffersSimpleList from '../containers/job-offers/SimpleList'
import { useJobOffers } from '../containers/job-offers/hooks'
import BannerPremium from '../components/premium/Banner'
import PageSectionContainer from '../containers/layout/PageSection'

const Home = () => {
  const { t } = useI18N()
  const { currentUser, isSubscriptionActive } = React.useContext(CurrentUserContext)
  const location = useLocation()
  const navigate = useNavigate()

  React.useEffect(() => {
    const redirectPath = localStorage.getItem('auth_redirect_path')
    if(currentUser && location.pathname === '/' && redirectPath) {
      localStorage.removeItem('auth_redirect_path')
      navigate(redirectPath, { replace: true })
    }
  }, [])

  if(currentUser?.shouldCompleteOnboarding) {
    return <Navigate to='/onboarding' />
  }

  const maxItems = config.VITE_MAX_CAROUSEL_ITEMS

  return (
    <>
      <div className='mx-auto max-w-5xl text-center mt-4'>
        <GptForm />
        {!isSubscriptionActive && <BannerPremium />}
      </div>
      <PageSection title={t('videos.last')}>
        <div className='-translate-x-2'>
          <VideosCarousel queryFn={() => useLastVideos(maxItems)} />
        </div>
      </PageSection>

      <PageSection title={t('jobs.last')} link={{ to: '/jobs', label: t('common.seeAll') }}>
        <JobOffersSimpleList queryFn={() => useJobOffers(3)} />
      </PageSection>
      {/* <div className='bg-soft-green px-5'>
        <PageSection title={t('notifications.title')} link={{ to: '/notifications', label: t('common.seeAll', { context: 'fem' }) }}>
          <div className='-translate-x-2'>
            <LatestNotifications />
          </div>
        </PageSection>
      </div> */}
      <div className='grid grid-cols-1 sm:grid-cols-3 gap-y-6 sm:gap-12 mt-5 sm:mt-10'>
        <ContinueWatching />
        <div className='col-span-2'><NextEvents /></div>
      </div>
      <PageSection title={t('videos.recommended')}>
        <div className='-translate-x-2'>
          <VideosCarousel queryFn={() => useRecommendedVideos(maxItems)}  />
        </div>
      </PageSection>
      <PageSection title={t('documents.last')}>
        <div className='-translate-x-2'>
          <DocumentsCarousel queryFn={() => useLastDocuments(maxItems)} />
        </div>
      </PageSection>
      <PageSectionContainer title={t('videos.history')} link={{ to: '/history', label: t('common.seeAll') }} queryFn={() => useHistory(5)} hideWhenEmpty>
        <div className='-translate-x-2'>
          <VideosCarousel queryFn={() => useHistory(5)} />
        </div>
      </PageSectionContainer>
    </>
  )
}

export default Home
